module.exports = __webpack_public_path__ + "static/media/calendar-view.63cecc86.svg";